
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/pie-arc-label",
      function () {
        return require("private-next-pages/x/api/charts/pie-arc-label.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/pie-arc-label"])
      });
    }
  